import styled, { css } from 'styled-components';
import { DatePicker as AntDatePicker, type DatePickerProps as AntDatePickerProps } from 'antd';
import { getGeneralDatePickerStyle } from '../utils/getGeneralStyle';
import { getDisabledDatePickerStyle } from '../utils/getDisabledStyle';
import { getBorderStyle } from '../utils/getBorderStyle';
import { getClassBasedBorder } from '../utils/getClassBasedBorderStyle';

export const StyledDayjsDatePicker = styled(AntDatePicker)<AntDatePickerProps>`
  &&& {
    ${getGeneralDatePickerStyle()};

    ${({ disabled, status }) =>
      disabled
        ? getDisabledDatePickerStyle()
        : css`
            ${getBorderStyle(status)}
            ${getClassBasedBorder()}
          `};
  }
`;
